import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import UsersSearchSource from 'flarum/common/components/UsersSearchSource';
import IndexPage from 'flarum/common/components/IndexPage';

import LessonPlanDirectoryPage from './components/LessonPlanDirectoryPage';
import LessonPlanPage from './components/LessonPlanPage';
import LessonPlan from '../lib/models/LessonPlan';

import LessonPlanActivityType from '../lib/models/LessonPlanActivityType';
import LessonPlanDevelopmentalArea from '../lib/models/LessonPlanDevelopmentalArea';
import LearningOutcome from '../lib/models/LearningOutcome';

app.initializers.add('thedesktop/lesson-plans', (app) => {
  // app.routes['td-lesson-plans'] = { path: '/lesson-plans', component: IndexPage };
  /* app.routes['td-lesson-plans'] = {
    path: '/lesson-plans',
    resolver: {
      onmatch() {
        if (app.session.user == null) return '<div>Hello!</div>';

        return IndexPage;
      },
    },
  }; */

  // app.routes.td_lesson_plans = {
  //   path: '/lesson-plans',
  //   component: LessonPlanDirectoryPage,
  // };

  app.routes.lesson_plans = { path: '/lesson-plans', component: LessonPlanDirectoryPage };
  app.routes.lesson_plan = { path: '/lesson-plan/:id', component: LessonPlanPage };

  app.routes.lesson_plan_download = { path: '/lesson-plan/download/:id', component: LessonPlanPage };

  app.route.lesson_plan = (lesson_plan) => app.route('lesson_plan', { id: lesson_plan });

  app.store.models.lesson_plans = LessonPlan;

  app.store.models.lesson_plan_activity_types = LessonPlanActivityType;
  app.store.models.lesson_plan_developmental_areas = LessonPlanDevelopmentalArea;
  app.store.models.learning_outcomes = LearningOutcome;

  extend(UsersSearchSource.prototype, 'view', function (view, query) {
    if (!view || app.forum.attribute('userDirectoryDisableGlobalSearchSource')) {
      return;
    }

    query = query.toLowerCase();

    view.splice(
      1,
      0,
      m(
        'li',
        LinkButton.component(
          {
            href: app.route('td.lesson_plans', { q: query }),
            icon: 'fas fa-search',
          },
          app.translator.trans('td-lesson-plans.forum.search.lesson_plans_heading', { query })
        )
      )
    );
  });

  extend(IndexPage.prototype, 'navItems', (items) => {
    if (app.forum.attribute('canSeeUserDirectoryLink')) {
      items.add(
        'td-lesson-plans',
        LinkButton.component(
          {
            href: app.route('td.lesson_plans'),
            icon: 'far fa-address-book',
          },
          app.translator.trans('td-lesson-plans.forum.page.nav')
        ),
        85
      );
    }
  });
});
